export { default as ScalarButton } from "./ScalarButton.vue.js";
